module.exports = __webpack_public_path__ + "static/media/steam_launch8.631ed016.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/steam_launch8.png
// module id = 38
// module chunks = 0